import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { SocketioService } from '../services/socketio.service';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-remotevideo',
  templateUrl: './remotevideo.component.html',
  styleUrl: './remotevideo.component.scss',
})
export class RemotevideoComponent implements OnInit, AfterViewInit {
  @ViewChild('remoteVideo') private remoteVideo: ElementRef<HTMLVideoElement>;

  constructor(private ss: SocketioService, public apiservice: ApiService) {}

  ngOnInit(): void {
    this.ss.socket.on('video-pause-status', (user, status) => {
      if (status) {
        if (this.apiservice.remote_view_data.id === user.id) {
          this.apiservice.remote_view_data = user;
        }
      } else {
        if (this.apiservice.remote_view_data.id === user.id) {
          this.apiservice.remote_view_data = user;
          this.apiservice.remoteVideoStream.next(
            this.apiservice.remote_video['stream']
          );
        }
      }
    });

    this.ss.socket.on('audio-mute-status', (user, status) => {
      if (status) {
        if (this.apiservice.remote_view_data.id === user.id) {
          let audio = <MediaStream>this.remoteVideo.nativeElement.srcObject;
          let stream = audio.getAudioTracks();
          stream[0].enabled = false;
          this.apiservice.remote_view_data = user;
        }
      } else {
        if (this.apiservice.remote_view_data.id === user.id) {
          let audio = <MediaStream>this.remoteVideo.nativeElement.srcObject;
          let stream = audio.getAudioTracks();
          stream[0].enabled = true;
          this.apiservice.remote_view_data = user;
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.apiservice.remoteVideoStream.subscribe((value: MediaStream) => {
      if (value) {
        this.remoteVideo.nativeElement.srcObject = value;
      } else {
        if (this.remoteVideo.nativeElement.srcObject) {
          let tracks = (<MediaStream>(
            this.remoteVideo.nativeElement.srcObject
          )).getTracks();
          tracks.forEach((track) => track.stop());
          this.remoteVideo.nativeElement.srcObject = null;
        }
      }
    });
  }
}
